"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WLCountryCode = exports.TypeOfDeleteModal = exports.PayApplicationStatus = exports.PayAccountStatus = exports.HotelPolicy = exports.CompanyBookingAllowances = exports.BusinessType = exports.BusinessQuestionWhenTo = exports.BusinessQuestionType = exports.BusinessQuestionDefaultQuestionId = exports.BusinessQuestionDefaultHeader = void 0;
var BusinessQuestionType = exports.BusinessQuestionType = function (BusinessQuestionType) {
  BusinessQuestionType["PurchaseOrder"] = "purchase_order_number";
  BusinessQuestionType["CustomerReference"] = "customer_reference";
  return BusinessQuestionType;
}({});
var BusinessQuestionDefaultHeader = exports.BusinessQuestionDefaultHeader = function (BusinessQuestionDefaultHeader) {
  BusinessQuestionDefaultHeader["PurchaseOrder"] = "Purchase order number";
  BusinessQuestionDefaultHeader["CustomerReference"] = "Customer reference";
  return BusinessQuestionDefaultHeader;
}({});
var BusinessQuestionDefaultQuestionId = exports.BusinessQuestionDefaultQuestionId = function (BusinessQuestionDefaultQuestionId) {
  BusinessQuestionDefaultQuestionId["PurchaseOrder"] = "2";
  BusinessQuestionDefaultQuestionId["CustomerReference"] = "1";
  return BusinessQuestionDefaultQuestionId;
}({});
var BusinessQuestionWhenTo = exports.BusinessQuestionWhenTo = function (BusinessQuestionWhenTo) {
  BusinessQuestionWhenTo["Register"] = "Register";
  BusinessQuestionWhenTo["Booking"] = "Booking";
  return BusinessQuestionWhenTo;
}({});
var TypeOfDeleteModal = exports.TypeOfDeleteModal = function (TypeOfDeleteModal) {
  TypeOfDeleteModal["Card"] = "Card";
  TypeOfDeleteModal["Question"] = "Question";
  return TypeOfDeleteModal;
}({});
var CompanyBookingAllowances = exports.CompanyBookingAllowances = function (CompanyBookingAllowances) {
  CompanyBookingAllowances["PIB"] = "premierInnBreakfast";
  CompanyBookingAllowances["CB"] = "continentalBreakfast";
  CompanyBookingAllowances["FCB"] = "freeChildBreakfast";
  CompanyBookingAllowances["MD"] = "mealDeal";
  CompanyBookingAllowances["HB"] = "hubBreakfast";
  CompanyBookingAllowances["UW"] = "ultimateWifi";
  return CompanyBookingAllowances;
}({});
var PayApplicationStatus = exports.PayApplicationStatus = function (PayApplicationStatus) {
  PayApplicationStatus["Started"] = "Incomplete Application";
  PayApplicationStatus["Submitted"] = "Outstanding";
  PayApplicationStatus["Approved"] = "Accepted";
  PayApplicationStatus["Rejected"] = "Rejected";
  PayApplicationStatus["Cancelled"] = "Cancelled";
  return PayApplicationStatus;
}({});
var PayAccountStatus = exports.PayAccountStatus = function (PayAccountStatus) {
  PayAccountStatus["Active"] = "current";
  PayAccountStatus["Suspended"] = "stop";
  PayAccountStatus["SuspendedHold"] = "hold";
  PayAccountStatus["Closed"] = "closed";
  return PayAccountStatus;
}({});
var BusinessType = exports.BusinessType = function (BusinessType) {
  BusinessType["Charity"] = "Charity";
  BusinessType["Non_Profit_Charity"] = "Gemeinn\xFCtzige GmbH (gGmbH)";
  BusinessType["Non_Profit_Assoc"] = "Gemeinn\xFCtziger Verein";
  BusinessType["Registered_Non_Profit_Charity"] = "Eingetragener gemeinn\xFCtziger Verein";
  BusinessType["GovernmentFundedSchool"] = "Gov. funded School/College";
  BusinessType["Government"] = "Government";
  BusinessType["Government_DE"] = "Regierungsorganisation";
  BusinessType["LimitedCompany"] = "Limited Company or LLP";
  BusinessType["LimitedCompany_DE"] = "Gesellschaft mit beschr\xE4nkter Haftung";
  BusinessType["LimitedCompany_Partnership_Shares"] = "Kommanditgesellschaft auf Aktien";
  BusinessType["LimitedCompany_Partnership"] = "Kommanditgesellschaft";
  BusinessType["Partnership"] = "Partnership";
  BusinessType["Partnership_DE"] = "Partnerschaftsgesellschaft";
  BusinessType["Partnership_General"] = "Offene Handelsgesellschaft";
  BusinessType["PublicLimited"] = "Public Limited Company";
  BusinessType["PublicLimited_DE"] = "Aktiengesellschaft";
  BusinessType["SoleTrader"] = "Sole Trader";
  BusinessType["SoleTrader_Registered_Merchant"] = "Eingetragener Kaufmann";
  BusinessType["SoleTrader_Merchant"] = "Kaufmann";
  BusinessType["SoleTrader_Proprietorship"] = "Einzelunternehmen";
  BusinessType["Other_Entrepreneurial_Society"] = "Unternehmergesellschaft";
  BusinessType["Other_Association_Incl_Charity"] = "Eingetragener Verein";
  BusinessType["Other"] = "Other";
  BusinessType["Other_DE"] = "Andere";
  return BusinessType;
}({});
var HotelPolicy = exports.HotelPolicy = function (HotelPolicy) {
  HotelPolicy["PI"] = "Only Premier Inn";
  HotelPolicy["PI_AND_OTHERS"] = "Premier Inn and other hotel brands";
  HotelPolicy["NOT_SET"] = "No set policy";
  return HotelPolicy;
}({});
var WLCountryCode = exports.WLCountryCode = function (WLCountryCode) {
  WLCountryCode["GB"] = "GBR";
  WLCountryCode["DE"] = "DEU";
  return WLCountryCode;
}({});